import { useState, useEffect } from 'react';

const useUserData = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const getUserDataFromStorage = () => {
      try {
        const storedData = localStorage.getItem('userData');
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          setUserData(parsedData);
        }
      } catch (error) {
        console.error('Error parsing userData from localStorage:', error);
        setUserData(null);
      }
    };

    getUserDataFromStorage();

  }, []);

  return userData;
};

export default useUserData;
